import {
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
} from '@chakra-ui/modal';
import Card from 'components/card';
import { MdWarning } from 'react-icons/md';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    invoice: any;
    onConfirm: (invoiceId: string) => void;
}

export default function VoidCreditNoteModal({ isOpen, onClose, invoice, onConfirm }: Props) {
    if (!invoice) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
            <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] top-[15vh]">
                <ModalBody>
                    <Card extra="px-[30px] pt-[25px] pb-[30px] max-w-[500px] flex flex-col !z-[1004]">
                        <div className="flex items-center gap-2 mb-4">
                            <MdWarning className="h-6 w-6 text-red-500 shrink-0" />
                            <h1 className="text-xl font-bold text-navy-700">
                                Annuler la facture d'avoir
                            </h1>
                        </div>
                        <p className="text-sm text-gray-600 mb-3">
                            Vous êtes sur le point d'annuler la facture d'avoir{' '}
                            <span className="font-bold text-navy-700">
                                #{invoice.invoiceNumber}
                            </span>{' '}
                            de{' '}
                            <span className="font-bold text-navy-700">
                                {invoice.customer}
                            </span>
                            .
                        </p>
                        <p className="text-sm text-gray-600 mb-6">
                            Son montant sera remis à zéro et elle n'impactera plus la
                            comptabilité. Si elle avait été imputée sur une facture,
                            celle-ci sera réouverte.
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                className="px-4 py-2 rounded-xl text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 transition"
                                onClick={onClose}
                            >
                                Annuler
                            </button>
                            <button
                                className="px-4 py-2 rounded-xl text-sm text-white bg-red-500 hover:bg-red-600 transition"
                                onClick={() => {
                                    onConfirm(invoice._id);
                                    onClose();
                                }}
                            >
                                Confirmer l'annulation
                            </button>
                        </div>
                    </Card>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
